import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeader } from "@/components/site/SectionHeader";
import { Reveal } from "@/components/site/Reveal";

export const faqs = [
  {
    q: "What is Velora Intelligence?",
    a: "Velora Intelligence is an AI-powered cryptocurrency intelligence platform. It helps you analyze crypto markets, discover opportunities, evaluate risk and monitor assets so you can make more informed decisions.",
  },
  {
    q: "Is Velora Intelligence an investment service?",
    a: "No. Velora Intelligence provides informational and analytical tools. It does not provide financial, investment, legal or tax advice, and it is not a broker, exchange or investment adviser.",
  },
  {
    q: "Does Velora Intelligence guarantee profits?",
    a: "No. We do not guarantee any investment outcome. Cryptocurrency markets are volatile and involve substantial risk, including the possible loss of capital. Our tools are analytical and intended to inform your own decisions.",
  },
  {
    q: "How does the AI analysis work?",
    a: "The platform reviews multiple market and technical factors to produce an AI Score, a Risk Score, a recommendation and time-based outlooks. These outputs are analytical signals designed to help you understand an asset, not directives to buy or sell.",
  },
  {
    q: "What is Presale Intelligence?",
    a: "Presale Intelligence lets you analyze crypto presales using AI-powered intelligence and external market information where available. As with all our tools, it is analytical and does not guarantee results.",
  },
  {
    q: "What is AI Smart Monitoring?",
    a: "Smart Monitoring lets you follow selected crypto assets and receive intelligent notifications and monitoring insights, helping you stay aware of relevant changes.",
  },
  {
    q: "Is there a free plan?",
    a: "Yes. The Free plan includes 7 AI crypto analyses per month, 2 presale intelligence analyses per month and basic platform access. You can upgrade to Premium inside the app.",
  },
  {
    q: "Where can I download the app?",
    a: "Velora Intelligence will be available on the Apple App Store and Google Play. Store links will be published here as soon as the listings are live.",
  },
  {
    q: "Is my financial information safe?",
    a: "We take privacy and security seriously and follow good security practices. Please review our Privacy Policy for details on how information is handled.",
  },
];

export const FAQSection = ({ withHeader = true }) => (
  <section
    id="faq"
    className="relative z-10 mx-auto max-w-3xl scroll-mt-24 px-4 py-24 sm:px-6 md:py-32"
    data-testid="faq-section"
  >
    {withHeader && (
      <SectionHeader
        label="FAQ"
        title="Questions, answered"
        align="center"
      />
    )}
    <Reveal className="mt-12">
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="border-white/8"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="text-left font-display text-base font-semibold text-white hover:text-teal-400 hover:no-underline md:text-lg">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-white/60 md:text-base">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
